import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { QRCodeSVG } from 'qrcode.react';

import { getOrganisationProfile } from '../../../services/api/organisationProfileApi';

import './ScanCounterPrintCard.css';

const btnGhost = 'px-4 py-2 rounded-lg border border-slate-400 dark:border-slate-500 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm font-semibold';

/**
 * Print view of ONE counter (A5-ish card). Print-only CSS hides everything except the card, so the
 * rest of the page never lands on paper. The QR text comes from the server (qr_text) as-is.
 */
export default function ScanCounterPrintCard({ counter, onClose }) {
  const [orgName, setOrgName] = useState('');

  // One cached fetch when the print view opens; a failure just leaves the name off (never blocks printing).
  useEffect(() => {
    let alive = true;
    getOrganisationProfile().then((p) => { if (alive && p?.name) setOrgName(p.name); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return createPortal(
    <div className="ssc-print-overlay" role="dialog" aria-label={`Print counter ${counter.counterId}`} data-testid="ssc-print-view">
      <div className="ssc-print-wrap">
        <div className="ssc-print-card" data-testid="ssc-print-card">
          {orgName && <div className="ssc-print-org" data-testid="ssc-print-org">{orgName}</div>}
          <div className="ssc-print-name">{counter.name}</div>
          <div className="ssc-print-type">Counter {counter.counterId} · {counter.type}</div>
          <div className="ssc-print-qr"><QRCodeSVG value={counter.qrText} size={240} level="M" /></div>
          <div className="ssc-print-line">Scan with your ABHA app to share your profile</div>
        </div>
        <div className="ssc-print-actions">
          <button type="button" data-testid="ssc-print-go" onClick={() => window.print()} className="px-4 py-2 rounded-lg bg-teal-600 text-white text-sm font-semibold">Print this card</button>
          <button type="button" data-testid="ssc-print-close" onClick={onClose} className={btnGhost}>Close</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
